import { AlertTriangle } from "lucide-react";

export function PerfRegressionBadge({ flags }: { flags: string[] }) {
  if (!flags || flags.length === 0) return null;
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-amber-900/40 text-amber-300"
      title={`Regresja p95 (>25% vs mediana 7 ostatnich lub >5000 ms): ${flags.join(", ")}`}
    >
      <AlertTriangle size={10} />
      regresja ({flags.length})
    </span>
  );
}
